import { request } from '../../helpers/api/request';
import { FeedContract } from '../../types/Endpoints/feeds';

export const getFeed = async (id: number) => {
    const { data } = await request<FeedContract>({
        url: `admin/feeds/${id}`,
    });

    return {
        ...data,
        properties: data.properties.map(({
            isEnabled, key, value, isDuplicateProductType,
        }) => ({
            isEnabled, key, value, isDuplicateProductType,
        })),
    };
};
